'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "className"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { ecx } from "../../utils.mjs";
/**
 * @deprecated
 * This component will be archived soon.
 * Use the TabsList component instead.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navbar-navbarlist--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavBarList) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12653&t=X3Pv9ZLvoMIaXVBJ-1)
 */
export var NavBarList = /*#__PURE__*/React.forwardRef(function NavBarList(_ref, ref) {
  var as = _ref.as,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var Element = as || 'ul';
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    className: ecx(['nav-bar-list', 'baseline'], className),
    ref: ref,
    "data-encore-id": ENCORE_DATA_IDS.NavBarList
  }, props));
});